import type { ApolloCache } from '@apollo/client';
import type { FolderAsset } from '@frameio/graphql-client/generated';

export function writeFolderColors(
  cache: ApolloCache<unknown>,
  folderIds: readonly string[],
  userProvidedColor: string | null
) {
  for (const id of folderIds) {
    cache.modify<FolderAsset>({
      id: cache.identify({ __typename: 'FolderAsset', id }),
      fields: {
        userProvidedColor: () => userProvidedColor,
      },
    });
  }
}
